/** Feature keys that unlock the full company dashboard sidebar. */
export const COMPANY_DASHBOARD_FEATURES = [
    'dashboard',
    'manage_employees',
    'manage_contractors',
    'benefits',
    'deductions',
    'time_off',
    'reports',
    'location_management',
    'billing',
    'user_management',
    'multi_company',
    'reseller',
    'branding',
];

/** Use after switch-company when role is Reseller (or backend returns a thin list). */
export function featuresForCompanyContext(role, featuresFromApi) {
    if (role === 'Reseller') return [...COMPANY_DASHBOARD_FEATURES];
    if (Array.isArray(featuresFromApi) && featuresFromApi.length > 0) return featuresFromApi;
    return featuresFromApi || [];
}
